import { CrmSearch, ExtensibleReports, SalesViews } from '../../../filterQueryFormat/strategy/StrategyTypes';
import { SegmentationFiltersInstanceProvider } from '../../../state/SegmentationFiltersInstanceContext';
import { useContext, useEffect } from 'react';
import FiltersBarUI from './FiltersBarUI';
import SegmentationFiltersSharedContext, { SegmentationFiltersSharedProvider } from '../../../state/SegmentationFiltersSharedContext';
import TransparencyBarUI from './TransparencyBarUI';
import emptyFunction from 'react-utils/emptyFunction';
import enviro from 'enviro';
import { FiltersBarProvider } from './state/FiltersBarContext';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const FiltersBar = ({
  advancedFiltersButtonState,
  advancedFiltersValue,
  associatedRecord,
  customPropertyNames = [],
  defaultPropertyNames = [],
  enableAdvancedFiltersButton,
  enableClearAdvancedFiltersButton,
  enableCustomFilters,
  maxCustomQuickFilters = 5,
  enableReordering = false,
  enableAutoOpenInputPopovers = false,
  filterFamily,
  forceShowClearQuickFilters,
  onChange,
  onClearAdvancedFilters,
  onClearQuickFilters,
  onCustomPropertyNamesChange,
  onOpenAdvancedFilters,
  onUserAction,
  size = 'sm',
  strategy,
  value,
  showTransparencyBar = false,
  trackerInstance
}) => {
  const sharedContext = useContext(SegmentationFiltersSharedContext);

  // Enforce the maxCustomQuickFilters limit when it changes
  useEffect(() => {
    if (onCustomPropertyNamesChange && customPropertyNames.length > maxCustomQuickFilters) {
      onCustomPropertyNamesChange(customPropertyNames.slice(0, maxCustomQuickFilters));
    }
  }, [customPropertyNames, maxCustomQuickFilters, onCustomPropertyNamesChange]);
  if (strategy && Object.keys(sharedContext).length > 0) {
    const errorMessage = 'Detected usage of `SegmentationFiltersSharedProvider`. Did you mean you to also pass the `strategy` prop to `FiltersBar`?';
    if (enviro.isProd()) {
      throw new Error(errorMessage);
    } else {
      console.error(errorMessage);
      return /*#__PURE__*/_jsxs("div", {
        children: ["Error: ", errorMessage]
      });
    }
  }
  const filtersBarInstance = /*#__PURE__*/_jsx(SegmentationFiltersInstanceProvider, {
    baseFilterFamily: filterFamily,
    onChange: emptyFunction,
    quickFilters: value,
    onQuickFiltersChange: onChange,
    value: advancedFiltersValue || {
      filterGroups: [],
      objectTypeId: filterFamily
    },
    onUserAction: onUserAction,
    children: /*#__PURE__*/_jsxs(FiltersBarProvider, {
      advancedFiltersButtonState: advancedFiltersButtonState,
      associatedRecord: associatedRecord,
      customPropertyNames: customPropertyNames,
      defaultPropertyNames: defaultPropertyNames,
      enableAdvancedFiltersButton: enableAdvancedFiltersButton,
      enableAutoOpenInputPopovers: enableAutoOpenInputPopovers,
      enableClearAdvancedFiltersButton: enableClearAdvancedFiltersButton,
      enableCustomFilters: enableCustomFilters,
      enableReordering: enableReordering,
      forceShowClearQuickFilters: forceShowClearQuickFilters,
      maxCustomQuickFilters: maxCustomQuickFilters,
      onClearAdvancedFilters: onClearAdvancedFilters,
      onClearQuickFilters: onClearQuickFilters,
      onCustomPropertyNamesChange: onCustomPropertyNamesChange,
      onOpenAdvancedFilters: onOpenAdvancedFilters,
      size: size,
      children: [/*#__PURE__*/_jsx(FiltersBarUI, {}), showTransparencyBar && /*#__PURE__*/_jsx(TransparencyBarUI, {})]
    })
  });
  if (strategy) {
    return /*#__PURE__*/_jsx(SegmentationFiltersSharedProvider, {
      strategy: strategy,
      trackerInstance: trackerInstance,
      children: filtersBarInstance
    });
  }
  const hasStrategyFromSharedContext = sharedContext.props && sharedContext.props.strategy && (sharedContext.props.strategy.strategyType === CrmSearch || sharedContext.props.strategy.strategyType === SalesViews || sharedContext.props.strategy.strategyType === ExtensibleReports);
  if (!hasStrategyFromSharedContext) {
    const errorMessage = 'No detected usage of `SegmentationFiltersSharedProvider` and missing `strategy` prop. Please pass in a `strategy` prop to `FiltersBar` or wrap with `SegmentationFiltersSharedProvider`.';
    if (enviro.isProd()) {
      throw new Error(errorMessage);
    } else {
      console.error(errorMessage);
      return /*#__PURE__*/_jsxs("div", {
        children: ["Error: ", errorMessage]
      });
    }
  }
  return filtersBarInstance;
};
export default FiltersBar;